import React from 'react';
import {
  useParams,
} from "react-router-dom";
// import "./Home"
function Movie() {
  const getLink = (path) => `https://fsapi.xyz/tmdb-movie/${path}`;
  let { id } = useParams();
    return (
   
<div>
 <div style={{ fontSize: "20px" }}>
           Now Playing movie: {id}


           <div>
           <iframe   src={getLink(id)} sandbox="allow-forms
allow-pointer-lock
allow-same-origin
allow-scripts
allow-top-navigation"></iframe>
           </div>
         </div>
         </div>

    )
}

export default Movie
